/**
 * Text colour of a floating-toolbar chip (and the favourite timeframe segments
 * inside its group), from the chart theme tokens so it reads on light, dark and
 * black charts alike. The chip fills already use `--chart-text`; the text used
 * to be fixed dark-theme hex values, which washed out on a light chart.
 *
 * Rest mixes the text token 70% toward the canvas (about #a9afba in Edge Dark,
 * a readable dark grey in light), hover is the full text token, disabled mixes
 * 45%. The active (primary) colour is the caller's.
 */
export function chipTextColor({
  hover,
  disabled,
}: {
  hover?: boolean
  disabled?: boolean
}): string {
  if (disabled) return mix(45)
  if (hover) return 'hsl(var(--chart-text))'
  return mix(70)
}

function mix(percent: number): string {
  return `color-mix(in oklab, hsl(var(--chart-text)) ${percent}%, hsl(var(--chart-canvas)))`
}
